<template>
  <div v-if="visivel" class="w3-modal" style="display: block">
    <div class="w3-container w3-modal-content w3-animate-zoom">

      <header>
        <h4 class="texto-vermelho titulo">Pesquisar Condição de Pagamento</h4>
        <span
          @click="fechar()"
          class="w3-button w3-display-topright">&times;</span>
      </header>

      <exibir-processando v-if="processando"/>

      <div class="w3-col" v-if="mostrar_filtros">

        <div style="padding: 0">

          <div
            class="w3-col s2 m1 w3-dropdown-hover w3-transparent w3-center"
            style="margin-top: 22px;">

            <button class="w3-button w3-border texto-vermelho">
              <i class="fa fa-cog"></i>
            </button>

            <div
              class="w3-dropdown-content w3-bar-block w3-border"
              style="width: 0px;">

              <div
                :key="tipo_pesquisa.indice_tela"
                v-for="tipo_pesquisa in tipos_pesquisa">

                <button 
                  class="w3-bar-item w3-button botao-quadrado" 
                  @click="setChavePesquisa(tipo_pesquisa.indice_tela)">

                  <i :class="getIconeFiltro(tipo_pesquisa.indice_tela)"></i> 
                  <span>{{tipo_pesquisa.descricao_pesquisa}}</span>
                </button>

              </div>
            </div>
          </div>

          <div class="w3-col s10 m8 l9" style="padding-left:10px;">
            <label for="campoPesquisa">
              <span>{{tipos_pesquisa[indice_pesquisa].descricao_pesquisa}}</span>
            </label>
                
            <input 
              type="text"
              class="w3-input w3-border w3-block" 
              style="border-radius:4px" 
              v-model="chave_pesquisa"
              id="campoPesquisa"
              ref="campoPesquisa"
              autocomplete="off"
              :placeholder="tipos_pesquisa[indice_pesquisa].placeholder"
              v-on:keyup="converterMaiusculo()"
              v-on:keyup.enter="buscar()">
          </div>

          <div class="w3-col m3 l2 w3-padding-small" style="padding:0px 0"> 
            <button 
              class="w3-button w3-theme w3-right w3-col" 
              style="margin-top: 20px;"
              v-on:click="buscar()"
              :disabled="processando">
              <span>Pesquisar</span>
            </button>                  
          </div>
        </div>
      </div>

      <div
        v-if="(
          (dados_filtrados.length > 0) &&
          (!processando) &&
          (mostrar_filtros)
        )"
        class="w3-col w3-center"
        style="margin-top: 1px;">

        <i
          class="fas fa-caret-down"
          @click="mostrar_filtros = false"
          style="font-size: 24px; cursor: pointer;">
        </i>
      </div>

      <div class="w3-col w3-left">
        <button
          class="w3-bar-item w3-button w3-col w3-white w3-border w3-mobile"
          v-if="!mostrar_filtros" v-on:click="mostrar_filtros = !mostrar_filtros">
          <i class="fa fa-filter icone-vermelho"></i>
          <span> Mostrar filtros</span>
        </button>
      </div>

      <div class="w3-col" v-if="!mostrar_filtros">
        <div class="w3-col w3-margin-top w3-margin-bottom">            
          <div 
            v-show="dados_filtrados.length > 0" 
            class="w3-responsive w3-border-top w3-border-bottom"
            v-if="!mostrar_filtros" 
            style="max-height: calc(75vh - 300px); min-height: 200px; overflow: auto">
            
            <div 
              class="w3-show w3-border w3-container card-item w3-col" 
              @click="confirmar(condicao)"
              v-for="condicao in dados_filtrados" :key="condicao.condicao_id">             

                <div class="w3-col">
                  <label>{{condicao.condicao_id}}</label> - <strong class="w3-text-theme">{{condicao.nome}}</strong>
                </div>

                <div class="w3-col s12 m6 l4" style="font-size: 12px;">
                  <label>Tipo pagamento: <strong v-bind:style="getCorTipoPagamento(condicao.tipo_pagamento)"> {{condicao.tipo_pagamento_analitico}} </strong></label>
                </div>

                <div v-if="condicao.restrita == 'S'" class="w3-col s12 m6 l4" style="font-size: 12px;">
                  <strong class="w3-text-red">Restrita </strong>
                </div>
                
                <div  v-if="condicao.restrita == 'S'" class="w3-col s12 m6 l4" style="font-size: 12px;">
                  <label>Tipo preço: <strong style="color: #636363;"> {{condicao.tipo_preco_analitico}} </strong></label>
                </div>
            </div>

          </div>
        </div>

        <footer class="w3-container w3-col conteudo-centralizado"/>
      </div>
    </div>
  </div>
</template>

<script>
  import RCondicao from '@/components/Rest/RCondicao.js'
  import ExibirProcessando from '@/components/ExibirProcessando'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'

  export default {
    name: 'PesquisaCondicaoPagamento',

    components: {
      ExibirProcessando
    },

    data() {
      return {
        visivel: false,

        tipos_pesquisa: [
          {
            indice_tela: 0,
            tipo: 'COD',
            descricao_pesquisa: 'Código',
            placeholder: 'Digite o código'
          },

          {
            indice_tela: 1,
            tipo: 'NOM',
            descricao_pesquisa: 'Nome',
            placeholder: 'Digite o nome'
          }
        ],

        indice_pesquisa: 1,
        mostrar_filtros: true,
        dados_filtrados: [],
        chave_pesquisa: '',
        processando: false,
        liberada_cliente_simplificado: 'S',
        somente_empresas_liberadas: 'N',
      };
    },

    methods: {
      abrir(
        liberada_cliente_simplificado, 
        somente_empresas_liberadas
      ) {

        if (liberada_cliente_simplificado){
          this.liberada_cliente_simplificado = liberada_cliente_simplificado;
        }

        if (somente_empresas_liberadas){
          this.somente_empresas_liberadas = somente_empresas_liberadas;
        }

        this.visivel = true;
        this.indice_pesquisa = 1;
        this.chave_pesquisa = '';
        this.dados_filtrados = [];
        this.mostrar_filtros = true;
        this.$nextTick(() => this.$refs.campoPesquisa.focus());
      },

      fechar() {
        this.visivel = false;
      },

      confirmar(condicao) {
        this.fechar();
        this.$emit('confirmar', condicao);
      },

      async buscar() {
        this.dados_filtrados = [];
        this.processando = true;

        let parametros = {
          tipo: this.tipos_pesquisa[this.indice_pesquisa].tipo,
          chave: this.chave_pesquisa,
          liberada_cliente_simplificado: this.liberada_cliente_simplificado,
          somente_empresas_liberadas: this.somente_empresas_liberadas
        }

        try {
          let retorno = await RCondicao.pesquisarCondicoesPagamento(this.axios, parametros);
          
          if (retorno.houve_erro == 'S') {
            throw new Error(retorno.mensagem);
          }

          this.dados_filtrados = JSON.parse(JSON.stringify(retorno.dados));
          this.mostrar_filtros = false;
          this.processando = false;
        }
        catch (e) {
          this.processando = false;
          this.chave_pesquisa = '';
          Biblioteca.exclamar(e.message);
        }
      },

      setChavePesquisa(indice) {
        this.indice_pesquisa = indice;
      },

      getIconeFiltro(indice) {
        if (indice == this.indice_pesquisa) {
          return 'fa fa-check-square icone-vermelho';
        }

        return 'far fa-square';
      },

      converterMaiusculo() {
        this.chave_pesquisa = this.chave_pesquisa.toUpperCase();
      },

      getCorTipoPagamento(tipo_pagamento){
        if (tipo_pagamento == 'P'){
          return 'color: #33732e;';
        }
        else {
          return 'color: #175aa6;';
        }
      },

    }
  }
</script>

<style escoped>
  @media screen and (min-width: 1200px) {
    .w3-modal-content {
      width: 80%;
    }
  }

  @media screen and (max-width: 1199px) {
    .w3-modal-content {
      width: 95%;
    }
  }

  .fundo-enfase {
    background-color: #dedede;
  }

  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    cursor: pointer;
  }
</style>





// WEBPACK FOOTER //
// src/components/Pesquisas/PesquisaCondicoesPagamento.vue